import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ServiceService } from 'src/app/service.service';

@Component({
  selector: 'app-torneado',
  templateUrl: './torneado.page.html',
  styleUrls: ['./torneado.page.scss', '../../../assets/scss/styles.scss'],
})
export class TorneadoPage implements OnInit {


  mensaje: string;
  typeMessage: string;
  revo: FormGroup;
  result: number;
  isMovil:boolean;

  constructor(private router: Router, public services: ServiceService, private form: FormBuilder) {
    this.revo = this.form.group({
      cantidad: [''],
      valor: [''],
      tipo: ['']
    });
  }

  ngOnInit() {
    this.isMovil = this.services.isMovil();
    let conta: number = 0;
    this.revo.get('tipo').valueChanges.subscribe( res => {
      conta++;
      this.typeMessage = res;
      if (res === 'Diámetro en pulgadas') {
        if (conta >1 ) {
          const valor = this.cemPulg(this.revo.get('cantidad').value);
          this.revo.get('cantidad').setValue(valor);
        }
      } else {
        if (conta >1 ) {
          const valor = this.PulugCem(this.revo.get('cantidad').value);
          this.revo.get('cantidad').setValue(valor);
        }
      }
    });
  }

  calcular() {
    if (this.revo.get('tipo').value === 'Diámetro en pulgadas') {
      const op = parseFloat(this.revo.get('cantidad').value) *  3.8197;
      this.result = Math.round(op / this.revo.get('valor').value);
      this.mensaje = 'RPM';
    } else {
      this.result = Math.round( (this.revo.get('valor').value *  318.3091) / this.revo.get('cantidad').value);
      this.mensaje = 'RPM';
    }
    this.services.addPointCalculator();
  }

  home() {
    return this.router.navigate(['/calculadora']);
  }

  routesTab(option: number) {
    switch (option){
      case 1: this.router.navigate(['/revo']); break;
      case 2: this.router.navigate(['/velocity']); break;
      case 3: this.router.navigate(['/avan']); break;
      case 4: this.router.navigate(['/marche']); break;
      case 5: this.router.navigate(['/torneado']); break;
    }
  }


  cemPulg( valor: number) {
      return (.1 * valor) / 2.54;
  }

  PulugCem(valor: number){
    return valor * 25.4;
  }

}
